<template>
  <!-- 审核问题统计 -->
  <div class="problemStatistics">
    <!-- 标题 -->
    <div class="title">
      <div class="title_left">
        <el-divider direction="vertical"></el-divider>
        <span>审核问题统计</span>
      </div>
      <div class="title_right">
        <span class="total">问题总数：<p>{{ dataList.totalNum }}例</p></span>
        <span>所属部门：</span>
        <el-cascader ref="department" v-model="department" :options="departments" size="small" clearable placeholder="全部"
          :props="{value: 'deptId', label: 'deptName', children: 'children', checkStrictly: true}" @change="setOption">
        </el-cascader>
      </div>
    </div>

    <!-- 图框 -->
    <div class="board">
      <!-- 环状图 -->
      <div class="circleBoard">
        <span>问题专业占比及严重等级占比</span>
        <!-- 问题专业分布图 -->
        <div id="specChart3" ref="specChart" class="circleSlider"></div>
        <!-- 严重等级分布图 -->
        <div id="severityChart3" ref="severityChart" class="circleSlider"></div>
      </div>

      <!-- 柱状图 -->
      <div class="barBoard">
        <span>项目问题统计表</span>
        <!-- 项目问题统计图 -->
        <div id="queStatChart3" ref="queStatChart" class="barSlider"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import dataBoardService from "@/CommonDP/service/dataBoard-service.js";
import * as echarts from 'echarts';
var specChart; // 问题专业分布图
var severityChart; // 严重等级分布图
var queStatChart; // 项目问题统计图

export default {
  components: {},
  props: ["questionType", "region", "startDate", "endDate"],
  data() {
    return {
      department: [],
      departments: [], // 部门

      dataList: {
        prjQuestionDistribution: [], // 项目问题统计表
        severityLevelDistribution: [], // 严重等级分布
        specDistribution: [], // 专业分布
        totalNum: 0 // 问题总数
      }
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  mounted() {
    this.getDepartments();
    this.init();
  },
  methods: {
    // 获得部门
    async getDepartments() {
      const res = await dataBoardService.getDepartments(this.enterpriseId);
      this.departments = this.getTreeData(res.data);
    },

    // 递归判断列表，把最后的children设为undefined
    getTreeData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].children.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].children = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.getTreeData(data[i].children);
        }
      }
      return data;
    },

    // 审核问题统计数据
    async getQuestionDashboard() {
      const params = {
        category: this.questionType,
        enterpriseId: this.enterpriseId,
        typeId: "t180000000008620", // 审核
        deptId: this.department[this.department.length - 1] || "", // 部门id
        cityCode: this.region || "", // 	城市编码
        startDate: this.startDate, // 开始时间
        endDate: this.endDate // 结束时间
      };
      const res = await dataBoardService.getQuestionDashboard(params);
      this.dataList = res.data;
    },

    // 初始化
    init() {
      specChart = echarts.init(this.$refs.specChart); // 问题专业分布图
      severityChart = echarts.init(this.$refs.severityChart); // 严重等级分布图
      queStatChart = echarts.init(this.$refs.queStatChart); // 项目问题统计图
      this.setOption();
    },

    // 加载数据
    setOption() {
      this.getQuestionDashboard().then(() => {
        // 问题专业分布图,严重等级分布图
        let title = "";
        let legendData = [];
        let seriesData = [];
        const option = {
          title: {
            text: "",
            top: "46%",
            left: "22.5%",
            textStyle: {
              fontFamily: "PingFang SC",
              fontSize: 14,
              fontWeight: "bold",
              color: "#666666"
            }
          },
          // 图例
          legend: {
            type: "scroll",
            orient: "vertical", // 垂直布局
            left: "65%",
            y: "center",
            data: []
          },
          // 列表
          series: [
            {
              type: "pie",
              radius: ["58%", "80%"],
              center: ["32%", "50%"],
              label: {
                show: false
              },
              data: []
            }
          ],
          // 提示
          tooltip: {
            trigger: "item",
            backgroundColor: "rgba(0, 0, 0, 0.62)",
            padding: [10, 30, 10, 10],
            borderWidth: 0,
            textStyle: {
              fontFamily: "PingFang SC",
              fontSize: 14,
              color: "#ffffff"
            },
            extraCssText: "line-height: 24px", // 行高
            formatter(e) {
              return e.marker + " " + e.name + "<br>" + "&nbsp;&nbsp;&nbsp;&nbsp;" + "问题数：" + e.value + "<br>" + "&nbsp;&nbsp;&nbsp;&nbsp;" + "占比：" + e.percent + "%";
            }
          }
        };
        title = "问题专业分布";
        const specList = this.dataList.specDistribution.filter((item) => item.num !== 0);
        legendData = specList.map((item) => item.name);
        seriesData = specList.map((item) => {
          return { name: item.name, value: item.num };
        });
        option.title.text = title;
        option.legend.data = legendData;
        option.series[0].data = seriesData;
        specChart.setOption(option, true);

        title = "问题严重等级";
        const severityList = this.dataList.severityLevelDistribution.filter((item) => item.num !== 0);
        legendData = severityList.map((item) => item.name);
        seriesData = severityList.map((item) => {
          return { name: item.name, value: item.num };
        });
        option.title.text = title;
        option.legend.data = legendData;
        option.series[0].data = seriesData;
        severityChart.setOption(option, true);

        // 项目问题统计图
        const x_projects = this.dataList.prjQuestionDistribution.map((item) => item.prjName);
        const pendingNum = this.dataList.prjQuestionDistribution.map((item) => item.pendingNum);
        const modifiedNum = this.dataList.prjQuestionDistribution.map((item) => item.modifiedNum);
        const option2 = {
          color: ["#FE838C", "#639BFF"],
          // 图例
          legend: {
            orient: "horizontal", // 水平布局
            bottom: "0%",
            x: "center",
            itemGap: 50, // 间隔
            data: ["待处理", "已解决"]
          },
          // x轴
          xAxis: [
            {
              type: "category",
              offset: 6,
              data: x_projects,
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#DCDCDC"
                }
              }, // 轴线
              axisLabel: { color: "#646464", rotate: 35 }, // 标签颜色和倾斜
              axisTick: {
                show: false
              } // 刻度
            }
          ],
          // y轴
          yAxis: {
            type: "value",
            axisLine: {
              show: true,
              lineStyle: {
                color: "#DCDCDC"
              }
            }, // 轴线
            axisLabel: { color: "#646464" }, // 标签
            splitLine: {
              lineStyle: {
                type: "dashed",
                color: "#F5F5F5"
              }
            } // 分割线
          },
          // 坐标轴定位
          grid: {
            top: "10%",
            width: "100%",
            left: "0",
            containLabel: true
          },
          // 滚动滑块
          dataZoom: [
            {
              startValue: 0,
              endValue: 9,
              zoomLock: false, // 锁定滑块大小
              handleSize: 6,
              showDetail: false, // 滑块两端信息
              showDataShadow: false, // 数据阴影可以简单地反应数据走势
              brushSelect: false,
              show: true,
              height: 6,
              right: 6,
              backgroundColor: "rgba(220, 220, 220, 0.3)", // 背景颜色
              borderColor: "rgb(0 0 0 0.3);", // 边框颜色
              fillerColor: "rgba(200, 200, 200, 0.88)", // 滑块颜色
              handleIcon: "circle", // 滑块两端圆形
              handleStyle: {
                color: "rgba(200, 200, 200, 1)", // 滑块两端圆形颜色
                borderWidth: 0
              }
            }
          ],
          // 列表
          series: [
            {
              name: "待处理",
              type: "bar",
              barWidth: 20, // 柱图宽度
              data: pendingNum
            },
            {
              name: "已解决",
              type: "bar",
              barWidth: 20, // 柱图宽度
              data: modifiedNum
            }
          ],
          // 提示
          tooltip: {
            trigger: "axis",
            backgroundColor: "rgba(0, 0, 0, 0.62)",
            padding: [15, 20, 15, 15],
            borderWidth: 0,
            textStyle: {
              fontFamily: "PingFang SC",
              fontSize: 14,
              color: "#ffffff"
            },
            extraCssText: "line-height: 24px",
            axisPointer: {
              type: "shadow"
            }
          }
        };
        if (x_projects.length < 11) option2.dataZoom = [];
        queStatChart.setOption(option2, true);
      });
    },

    // 导出PPT所用的数据
    slideData(title) {
      const total = this.dataList.totalNum;
      let deptName = "全部";
      const node = this.$refs.department.getCheckedNodes()[0];
      if (node) deptName = node.pathLabels.join("/");
      const chartBase64List = [
        "{{" + this.createBase64("#specChart3") + "}}",
        "{{" + this.createBase64("#severityChart3") + "}}",
        "{{" + this.createBase64("#queStatChart3") + "}}"
      ];
      return { title, total, deptName, chartBase64List };
    },
    // echarts图表转化为base64
    createBase64(ele) {
      const docEle = ele + " canvas";
      const canvasFixed = document.querySelector(docEle); // 获取图表元素
      const canvasWidth = canvasFixed.width; // 获取图表元素宽度
      const canvasHeigth = canvasFixed.heigth; // 获取图表元素高度
      const canvas2D = canvasFixed.getContext("2d");
      canvas2D.drawImage(canvasFixed, canvasWidth, canvasHeigth);
      return canvasFixed.toDataURL();
    },
    // 导出Excel所用的数据
    conditionData() {
      const typeId = "t180000000008620";
      const deptId = this.department[this.department.length - 1] || "";
      return { typeId, deptId };
    }
  }
};
</script>

<style lang="scss" scoped>
.problemStatistics {
  width: 100%;

  .title {
    width: 100%;
    padding: var(--small-space) var(--big-space);
    border-bottom: 1px solid #e6eaf8;
    border-radius: 4px 4px 0 0;
    background-color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title_left {
      display: flex;
      align-items: center;

      .el-divider {
        background-color: var(--theme-color);
        width: 3px;
        height: 15px;
        margin: 0 8px 0 0;
      }

      span {
        font-size: 16px;
        line-height: 22px;
        font-weight: 700;
        color: var(--key-color);
        white-space: nowrap;
      }
    }

    .title_right {
      display: flex;
      align-items: center;

      .total {
        font-weight: 700;
        font-size: 14px;
        line-height: 20px;
        display: flex;
        align-items: center;

        p {
          color: #4777e7;
          font-weight: 700;
          font-size: 14px;
          line-height: 20px;
        }
      }

      span {
        font-family: "Microsoft YaHei UI";
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        color: var(--common-color);
        white-space: nowrap;

        padding-left: 25px;
      }
    }
  }

  .board {
    width: 100%;
    padding: var(--big-space) 0;
    border-radius: 0 0 4px 4px;
    background-color: white;

    .circleBoard {
      width: 100%;
      padding: 10px 120px 20px 80px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      span {
        font-size: 15px;
        line-height: 21px;
        font-weight: 700;
        color: var(--key-color);
        white-space: nowrap;
      }

      .circleSlider {
        width: 500px;
        height: 280px;
      }
    }

    .barBoard {
      width: 100%;
      padding: 20px 120px 10px 80px;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;

      span {
        font-size: 15px;
        line-height: 80px;
        font-weight: 700;
        color: var(--key-color);
        white-space: nowrap;
      }

      .barSlider {
        width: 1300px;
        height: 400px;
      }
    }
  }
}
</style>
